import React from 'react';
import {
  Box,
  Button,
  IconButton,
  TextField,
  Typography,
} from '@material-ui/core';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faMapPin, faImages} from '@fortawesome/pro-regular-svg-icons';
import {IGeneralNoteFormProps} from './AddNewDataPointForm.types';
import {NOTE_TITLE_MAX, NOTE_BODY_MAX} from './AddNewDataPointForm.constants';

import {Autocomplete} from '@react-google-maps/api';

export const GeneralNoteForm: React.FC<IGeneralNoteFormProps> = ({
  location,
  noteTitle,
  notes,
  uploadedImages,
  onLocationChange,
  onNoteTitleChange,
  onNotesChange,
  onImageUploadClick,
  onChooseOnMap,
}) => {
  const [autocomplete, setAutocomplete] =
    React.useState<google.maps.places.Autocomplete | null>(null);

  const onLoad = (autocompleteInstance: google.maps.places.Autocomplete) => {
    setAutocomplete(autocompleteInstance);
  };

  const onPlaceChanged = () => {
    if (autocomplete !== null) {
      const place = autocomplete.getPlace();
      if (place.formatted_address) {
        onLocationChange(place.formatted_address);
      } else if (place.name) {
        onLocationChange(place.name);
      }
    }
  };

  return (
    <>
      <Box mb={2}>
        <Typography style={{fontSize: 14, fontWeight: 500, marginBottom: 6}}>
          Location (optional)
        </Typography>
        <Autocomplete
          onLoad={onLoad}
          onPlaceChanged={onPlaceChanged}
          options={{componentRestrictions: {country: 'za'}}}
        >
          <TextField
            fullWidth
            variant="outlined"
            size="small"
            placeholder="Search address or enter co-ordinates"
            value={location}
            onChange={(e) => onLocationChange(e.target.value)}
            InputProps={{style: {backgroundColor: '#fff', borderRadius: 8}}}
          />
        </Autocomplete>
        <Button
          size="small"
          style={{
            marginTop: 6,
            color: '#2D9B73',
            textTransform: 'none',
            padding: 0,
            minWidth: 'auto',
          }}
          startIcon={<FontAwesomeIcon icon={faMapPin} />}
          onClick={() => onChooseOnMap?.()}
        >
          Choose on map
        </Button>
      </Box>

      <Box mb={2}>
        <Typography style={{fontSize: 14, fontWeight: 500, marginBottom: 6}}>
          Note title
        </Typography>
        <TextField
          fullWidth
          variant="outlined"
          size="small"
          placeholder="Add title"
          value={noteTitle}
          onChange={(e) =>
            onNoteTitleChange(e.target.value.slice(0, NOTE_TITLE_MAX))
          }
          inputProps={{maxLength: NOTE_TITLE_MAX}}
          InputProps={{style: {backgroundColor: '#fff', borderRadius: 8}}}
          helperText={`${noteTitle.length}/${NOTE_TITLE_MAX} characters`}
        />
      </Box>

      <Box mb={2}>
        <Typography style={{fontSize: 14, fontWeight: 500, marginBottom: 6}}>
          Notes
        </Typography>
        <TextField
          fullWidth
          multiline
          rows={4}
          variant="outlined"
          size="small"
          placeholder="Add notes"
          value={notes}
          onChange={(e) =>
            onNotesChange(e.target.value.slice(0, NOTE_BODY_MAX))
          }
          inputProps={{maxLength: NOTE_BODY_MAX}}
          InputProps={{style: {backgroundColor: '#fff', borderRadius: 8}}}
          helperText={`${notes.length}/${NOTE_BODY_MAX} characters`}
        />
        <Box mt={1} display="flex" style={{gap: 8}}>
          <IconButton
            size="small"
            style={{padding: 4}}
            onClick={onImageUploadClick}
            title="Upload image"
          >
            <FontAwesomeIcon icon={faImages} style={{fontSize: 18}} />
          </IconButton>
          <IconButton size="small" style={{padding: 4}} title="Attach file">
            <span style={{fontSize: 18}}>📎</span>
          </IconButton>
        </Box>
        {uploadedImages.length > 0 && (
          <Typography
            variant="body2"
            style={{marginTop: 4, color: '#2D9B73', fontWeight: 500}}
          >
            {uploadedImages.length} image(s) selected
          </Typography>
        )}
      </Box>
    </>
  );
};
